/**
 * vue-tags-input does not text-filter its `autocomplete-items` — its
 * `filteredAutocompleteItems` only drops duplicates. Narrowing the list as the
 * user types is the caller's job, so every tags-input filter in this app runs
 * its options through here rather than re-deriving the match rule.
 */
export function matchesQuery(
  query: string | null | undefined,
  ...candidates: Array<string | null | undefined>
): boolean {
  const needle = (query || '').trim().toLowerCase()

  // An empty box is not a filter: show the caller's full list.
  if (!needle) {
    return true
  }

  return candidates.some(candidate =>
    (candidate || '').toLowerCase().includes(needle)
  )
}
